<template>
  <pagefra>
    <div class="supervise container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <!-- <el-form-item label="所属区域">
              <areaCascader ref="ac" :multiple="true" :checkStrictly="true"></areaCascader>
            </el-form-item> -->
            <el-form-item :label="$l('所属城市')">
              <el-input
                v-model="form.city"
                :placeholder="$l('所属城市')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('计划作业时间')">
              <el-date-picker
                v-model="planStartTimeValues"
                type="daterange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始时间')"
                :end-placeholder="$l('结束时间')"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <personLocation :selectedList="selectedList"></personLocation>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              :label="$l('序号')"
              type="index"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('大楼名称')"
              prop="buildingName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('梯号')"
              prop="elevatorNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="jobNum"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('计划作业时间')"
              prop="planStartDt"
              align="center"
              min-width="150"
              sortable
              :formatter="formatterPlanStart"
            ></el-table-column>
            <el-table-column
              :label="$l('计划作业时长(分)')"
              prop="stdTime"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <!-- <el-table-column :label="$l('作业项目')" prop="planType" align="center" min-width="150"></el-table-column> -->
            <el-table-column
              :label="$l('设备监督')"
              prop="isMug"
              align="center"
              min-width="150"
              v-if="hasFieldPermission('设备监督')"
            >
              <template slot-scope="scope">
                <el-tag
                  type="primary"
                  size="medium"
                  effect="plain"
                  round
                  v-if="scope.row.isMug == 0"
                  >{{ $l("不符合") }}
                </el-tag>
                <el-tag
                  v-else
                  type="info"
                  size="medium"
                  effect="plain"
                  round
                  style="width: 5em"
                  >{{ $l("符合") }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('停梯开始时间')"
              prop="startDate"
              align="center"
              min-width="150"
              sortable
              v-if="hasFieldPermission('停梯开始时间')"
            ></el-table-column>
            <el-table-column
              :label="$l('停梯结束时间')"
              prop="endDate"
              align="center"
              min-width="150"
              sortable
              v-if="hasFieldPermission('停梯结束时间')"
            ></el-table-column>
            <el-table-column
              :label="$l('设备记录停梯时长(分)')"
              prop="stopTimes"
              align="center"
              min-width="180"
              sortable
              v-if="hasFieldPermission('设备记录停梯时长')"
            ></el-table-column>
            <el-table-column
              :label="$l('计划1作业时间')"
              prop="planStartDt1"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('计划2作业时间')"
              prop="planStartDt2"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('计划3作业时间')"
              prop="planStartDt3"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('保养停梯时间') + 1"
              prop="mainstartdate1"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('保养结束停梯时间') + 1"
              prop="mainenddate1"
              align="center"
              min-width="180"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('保养停梯时间') + 2"
              prop="mainstartdate2"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('保养结束停梯时间') + 2"
              prop="mainenddate2"
              align="center"
              min-width="180"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('保养停梯时间') + 3"
              prop="mainstartdate3"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('保养结束停梯时间') + 3"
              prop="mainenddate3"
              align="center"
              min-width="180"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('保养停梯时间') + 4"
              prop="mainstartdate4"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('保养结束停梯时间') + 4"
              prop="mainenddate4"
              align="center"
              min-width="180"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('停梯明细')"
              min-width="100"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('停梯明细')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  class="table-icon"
                  @click="openElevatorStopDialog(scope.row.jobNum)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
      <el-dialog
        :title="$l('停梯明细')"
        :visible.sync="elevatorStopDialogVisible"
        width="900px"
      >
        <el-table
          size="medium"
          tooltip-effect="tableTooltip"
          highlight-current-row
          v-loading.lock="elevatorStopLoading"
          :data="elevatorStopTableData"
          style="width: 100%; z-index: 1000"
        >
          <el-table-column
            type="index"
            :label="$l('序号')"
            width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            :label="$l('地盘名称')"
            prop="domainName"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('电梯工号')"
            prop="jobNum"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('安装地址')"
            prop="installAddress"
            width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('停梯开始时间')"
            prop="startDate"
            width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('停梯结束时间')"
            prop="endDate"
            width="150"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$l('停梯时长')"
            prop="stopTimes"
            width="120"
            sortable
          ></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="elevatorStopDialogVisible = false"
            >{{ $l("关闭") }}
          </el-button>
        </div>
        <el-pagination
          :current-page="elevatorStopPageConfig.currentPage"
          :page-sizes="elevatorStopPageConfig.pageSizes"
          :page-size="elevatorStopPageConfig.pageSize"
          :total="elevatorStopPageConfig.total"
          @size-change="elevatorStopHandlePageSizeChange"
          @current-change="elevatorStopHandleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </el-dialog>
      <!-- <baidumap-js></baidumap-js> -->
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
// import areaCascader from "@/components/areaCascader.vue";
import personLocation from "@/components/personLocation.vue";
import global from "@/mixins/global.js";

export default {
  name: "supervise",
  mixins: [global],
  components: {
    panel,
    personLocation,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: this.$l("最近一周"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$l("最近一个月"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$l("最近三个月"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      form: {
        city: "",
        domainName: "",
        jobNum: "",
        planStartDateStr: "",
        startPlanDate: "",
        endPlanDate: "",
        dataPermissionList: [],
      },
      planStartTimeValues: [],
      tableData: [],
      loading: false,
      selectedList: [],
      elevatorStopDialogVisible: false,
      elevatorStopTableData: [],
      elevatorStopLoading: false,
      elevatorStopPageConfig: {
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
        pageSize: 10,
        total: 10,
      },
      currentJobNum: null,
    };
  },
  mounted() {
    let query = this.$route.query;
    const jobNum = query.jobNum;
    const planStartDt = query.planStartDt;
    if (jobNum == undefined) {
      this.planStartTimeValues = this.$common.getDateRange(0);
    } else if (planStartDt) {
      this.form.jobNum = jobNum;
      this.planStartTimeValues = [new Date(planStartDt), new Date(planStartDt)];
    }
    if (jobNum == undefined || (jobNum && planStartDt)) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.form.planStartDateStr = "";
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      // this.form.dataPermissionList = this.$refs.ac.getSelectedList();
      if (this.planStartTimeValues && this.planStartTimeValues.length == 2) {
        this.form.startPlanDate = this.$common.formatDate(
          this.planStartTimeValues[0]
        );
        this.form.endPlanDate = this.$common.formatDate(
          this.planStartTimeValues[1]
        );
      } else {
        this.form.startPlanDate = "";
        this.form.endPlanDate = "";
      }
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.search_main_supervise_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    elevatorStopHandlePageSizeChange(val) {
      this.elevatorStopPageConfig.pageSize = val;
      this.openElevatorStopDialog(this.currentJobNum);
    },
    elevatorStopHandleCurrentPageChange(val) {
      this.elevatorStopPageConfig.currentPage = val;
      this.openElevatorStopDialog(this.currentJobNum);
    },
    openElevatorStopDialog(jobNum) {
      this.currentJobNum = jobNum;
      this.elevatorStopDialogVisible = true;
      this.elevatorStopTableData = [];
      this.elevatorStopLoading = true;
      this.$http
        .post(this.$apiConfig.search_elevator_stop_url, {
          pageNum: this.elevatorStopPageConfig.currentPage,
          pageSize: this.elevatorStopPageConfig.pageSize,
          jobNum: jobNum,
          startDateStr: this.$common.formatCurrentMonth() + "-01 00:00:00",
          endDateStr: this.$common.formatCurrentDateTime(),
        })
        .then((response) => {
          this.elevatorStopLoading = false;
          let result = response.data;
          if (result.code == 0) {
            this.elevatorStopPageConfig.total = result.data.total;
            this.elevatorStopTableData = result.data.result;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.elevatorStopLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    formatterPlanStart(row) {
      if (row.planStartDt) {
        return row.planStartDt.split(" ")[0];
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.supervise {
}
</style>
